import { useQuery } from "@tanstack/react-query";
import { API_ROUTES } from "../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../api/PrivateAdminPanelInstance";

/**
 * GET /admin-panel/admin/v1/users/{admin_id} response.
 * Returns username, group_name, permissions for the staff details page.
 */
export interface StaffDetailsApiData {
  username?: string;
  group_name?: string;
  permissions?: string[];
  timezone?: string;
  mfa_enrolled?: boolean;
}

export interface StaffDetailsApiResponse {
  success?: boolean;
  data?: StaffDetailsApiData;
}

async function fetchStaffDetails(adminId: string): Promise<StaffDetailsApiData | null> {
  if (!adminId) return null;
  const token = JSON.parse(localStorage.getItem("token") || "null");
  const client = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.GET_STAFF_DETAILS.replace("{admin_id}", adminId);
  const res = await client.get(url);
  const payload = (res?.data ?? {}) as StaffDetailsApiResponse;
  return payload?.data ?? null;
}

/**
 * Fetches a single admin/staff details by admin_id.
 * Used when opening Staff Details from the Staff list (click First Name, Last Name, or Email).
 */
export function useGetStaffDetails(adminId: string | null | undefined) {
  return useQuery({
    queryKey: ["GET_STAFF_DETAILS", adminId ?? ""],
    queryFn: () => fetchStaffDetails(adminId!),
    enabled: Boolean(adminId),
    staleTime: 1000 * 60,
  });
}
